module.exports = __webpack_public_path__ + "1791188489487/fonts/Flaticon.89ed3c6.ttf";